const TYPE = 'ROUTING/LOCATION_CHANGE';

export const routingLocationChange = (location) => ({
    type: TYPE,
    payload: location,
});

const initialState = {
    locationBeforeTransitions: null,
};

export default function routingCompatReducer(state = initialState, action) {
    if (action.type === TYPE) {
        return { ...state, locationBeforeTransitions: action.payload };
    }
    return state;
}

export const selectLegacyLocation = (state) =>
    state?.routing?.locationBeforeTransitions || null;
